import { render } from "./PlanetTablet.vue?vue&type=template&id=64d7ee56&scoped=true"
import script from "./PlanetTablet.vue?vue&type=script&lang=ts"
export * from "./PlanetTablet.vue?vue&type=script&lang=ts"

import "./PlanetTablet.vue?vue&type=style&index=0&id=64d7ee56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64d7ee56"

export default script